import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function getLocalized(field, lang = 'da') {
  if (!field) return '';
  if (typeof field === 'string') return field;
  if (typeof field === 'object' && field !== null) {
    // Check for specific language key
    if (field[lang] !== undefined) return field[lang];
    // Check for default/underscore key
    if (field['_'] !== undefined) return field['_'];
    // Fallback to first available value
    const values = Object.values(field);
    if (values.length > 0) return values[0];
  }
  return String(field);
}
